
export const clinical = {
  dashboard: {
    loading: "Loading Dashboard...",
    title: "Clinic Overview",
    subtitle: "Summary of patient cases and plan usage",
    systemStatus: "System Normal",
    kpi: {
      netSales: "Net Sales",
      grossSales: "Gross Sales"
    },
    filters: {
      today: "Today",
      last7days: "Last 7 Days",
      last30days: "Last 30 Days"
    },
    table: {
      title: "Daily Breakdown",
      date: "Date"
    },
    planUsage: {
      title: "Plan Usage",
      caseLimit: "Case Limit",
      currentPlan: "Current Plan",
      resetDate: "Resets on the 1st of each month"
    },
    quickActions: {
      title: "Quick Actions",
      registerPatient: "Register Patient",
      doctorStation: "Doctor Station"
    }
  },
  customerManagement: {
    title: "Patient Registration",
    addNew: "Register New Patient",
    loading: "Loading Patients...",
    errorTitle: "Error",
    errorMessage: "Could not load patients.",
    deleteConfirm: "Are you sure you want to delete this patient record?",
    customerSince: "Patient since {{date}}",
    edit: "Edit Info",
    delete: "Delete",
    profileTab: "Profile",
    prescriptionsTab: "Prescriptions & Quota",
    empty: "No patients found.",
    table: {
      name: "Name",
      phone: "Phone",
      nationalId: "National ID",
      dob: "Date of Birth",
      actions: "Actions"
    }
  },
  telemedicine: {
    commandCenter: "Doctor Command Center",
    subtitle: "Monitor patients and approve prescriptions.",
    systemOnline: "System Online",
    waitingRoom: "Waiting Room",
    refresh: "Refresh",
    store: "Store",
    call: "Video Call",
    reviewSign: "Review & Sign",
    empty: {
      title: "Waiting Room is Empty",
      subtitle: "No patients are currently waiting for consultation."
    }
  }
};
